
import { defineComponent, ref, reactive, toRefs, onMounted, watch, watchEffect, onUnmounted, computed } from 'vue'
import { askApi } from '@/api/index'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import store from '@/store/index'
import { mapState, mapMutations, mapActions } from 'vuex'
export default defineComponent({
  props: {
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    theme: {
      type: String,
      default: () => {
        return 'light'
      }
    },
    keywords: {
      type: Object,
      default: () => {
        return {}
      }
    },
    AQContent: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  setup(props: any, context: any) {
    const route = useRoute()
    // const isGNTopActive = ref(false)
    const pageData = reactive({
      userToken: route.query.token,
      allAns: true,
      activeKey: ['1', '2', '3'],
      GNTop: [],
      StockTop: [],
      currentName: '',
      active: route.query.market && route.query.code ? '' : 'all',
      totalStock: 0,
      news: ['GN041354', '490100'],
      // timer: null
      isGNTopActive: false,
      isStockTopActive: false
    })
    // 清理过期localstorage
    function filterOverdueData() {
      const data = JSON.parse(localStorage.getItem('askingMenuRefreshTime') || 'null')
      if (!data) return
      const now = Math.round(Date.now() / 1000)
      const res = JSON.parse(JSON.stringify(data))
      ;(Object.keys(data) || []).map((item: any) => {
        const value = data[item].filter((element: any) => element.time > now - 86400)
        res[item] = value
      })
      localStorage.setItem('askingMenuRefreshTime', JSON.stringify(res))
    }
    filterOverdueData()

    watch(
      () => pageData.active,
      (newV: string, oldV: string) => {
        if (newV === 'all') {
          pageData.isGNTopActive = false
          pageData.isStockTopActive = false
          return
        }
        const res1 = (pageData.GNTop || []).findIndex((item: any) => item.Inst === newV) > -1
        const res2 = (pageData.StockTop || []).findIndex((item: any) => item.Inst === newV) > -1
        if (res1) {
          pageData.isGNTopActive = true
          pageData.isStockTopActive = false
        }
        if (res2) {
          pageData.isStockTopActive = true
          pageData.isGNTopActive = false
        }
      }
    )
    watch(
      () => props.token,
      (newV: string, oldV: string) => {
        if (newV !== oldV) {
          getTop10Data(newV)
        }
      }
    )
    watch(
      () => props.keywords,
      (val: any) => {
        if ((val.InstExt || []).length || (val.KeyWords || []).length) {
          pageData.isGNTopActive = false
          pageData.isStockTopActive = false
          pageData.active = ''
        }
      }
    )
    watch(
      () => props.AQContent,
      (val: any) => {
        if (pageData.active === 'all' && pageData.GNTop.length && pageData.StockTop.length) {
          const data = [...pageData.GNTop, ...pageData.StockTop]
          data.forEach((item: any) => {
            // isNew=true 有新消息，并且没有在content中打开
            item.isNew = item.isNew && notOpenByContent(item)
            if (!item.isNew) {
              setLocalData(item)
            }
          })
        }
      }
    )

    function getTop10Data(token: any) {
      // 概念
      const data: any = {}
      data.data = {}
      data.headers = {
        token: token
      }
      askApi.getInfoSecretaryTop(data).then((res: any) => {
        const result: any = res.Data
        context.emit('initInfoSecretaryTop', res.Data)
        ;(result.GNTop || []).forEach((item: any) => {
          item.time = getLocalDataTime(item)
        })
        pageData.GNTop = result.GNTop
        // refreshNew([...pageData.GNTop, ...pageData.StockTop], -1)
        getStockTop()
      })
    }
    function getLocalDataTime(item: any) {
      const key: any = (item.Inst || item.Symbol) + '.' + (item.Exch || item.Market)
      const t = (pageData.userToken || 'userToken') as string
      const localData = JSON.parse(localStorage.getItem('askingMenuRefreshTime') || '{}')
      const localItem = (localData[t] || []).find((element: any) => element.key === key)
      const time = localItem ? localItem.time : 0
      const now = Math.round(Date.now() / 1000)
      // 86400 = 24 * 60 * 60  24小时
      return now - time > 86400 ? now - 86400 : time // 确保loacalStorage保存的时间在24小时内
    }

    function getStockTop() {
      // 股票
      const data = {
        limit: 10
      }
      askApi.gethotSearchV2(data).then((res: any) => {
        if ((res.data || []).length === 0) {
          pageData.StockTop = []
          return
        }
        res.data.forEach((item: any) => {
          item.Inst = item.Symbol
          item.Exch = item.Market
          item.time = getLocalDataTime(item)
        })
        pageData.StockTop = res.data
        refreshNew([...pageData.GNTop, ...pageData.StockTop], -1)
        pageData.totalStock = (res.data || []).length
      })
    }
    function handlerMouseEnter(e: any, str: string) {
      if (e.target.clientWidth < e.target.scrollWidth) {
        pageData.currentName = str
      } else {
        pageData.currentName = ''
      }
    }
    // 判断红点菜单没有在content的数据中
    function notOpenByContent(item: any) {
      const res = props.AQContent.filter((element: any) => {
        return element.Exch === item.Exch && element.Inst === item.Inst
      })
      return res.length === 0
    }
    function handlerClick(item: any, type: string) {
      pageData.active = item.Inst
      item.type = type
      if (type === 'all') {
        // refreshNew([...pageData.GNTop, ...pageData.StockTop], -1)
      } else {
        const arr = [...pageData.GNTop, ...pageData.StockTop]
        const idx = arr.findIndex((item2: any) => item2.Inst === item.Inst)
        refreshNew(arr, idx)
      }
      context.emit('clickNav', item)
    }
    // arr 菜单数组，idx 更新的数组序号,-1 页面加载时全局更新，
    // 找离现在最近到一小时数组项，设置定时器
    let timer: any = null
    async function refreshNew(arr: any, idx: any, nextRefresh?: any) {
      if (!(arr || []).length) return
      timer && clearTimeout(timer)
      if (idx > -1) {
        arr[idx].isNew = false
        arr[idx].time = Math.round(Date.now() / 1000)
        setLocalData(arr[idx])
      } else if (idx === -1) {
        for (let i = 0; i < arr.length; i++) {
          const isNew = await checkNews(arr[i])
          arr[i].isNew = isNew && notOpenByContent(arr[i])
          arr[i].time = Math.round(Date.now() / 1000)
        }
      } else {
        if ((nextRefresh || []).length) {
          for (let i = 0; i < nextRefresh.length; i++) {
            arr[i].isNew = await checkNews(arr[i])
            arr[i].time = Math.round(Date.now() / 1000)
          }
        }
      }
      const now = Math.round(Date.now() / 1000)
      arr.sort((a: any, b: any) => {
        return a.time - b.time
      })
      const nextRefreshIdx: any = []
      arr.forEach((item: any, idx: number) => {
        if (item.time === arr[0].time) {
          nextRefreshIdx.push(idx)
        }
      })
      const delay = (3600 - (now - arr[0].time)) * 1000 // 3600
      timer = setTimeout(() => {
        // timer && clearTimeout(timer)
        refreshNew(arr, -2, nextRefreshIdx)
      }, delay)
    }
    interface localDataType {
      [key: string]: any
    }
    function setLocalData(item: any) {
      const localData: localDataType = JSON.parse(localStorage.getItem('askingMenuRefreshTime') || '{}')
      const t = (pageData.userToken || 'userToken') as string
      const key = (item.Inst || item.Symbol) + '.' + (item.Exch || item.Market)
      localData[t] = localData[t] || []
      const idx = localData[t].findIndex((element: any) => element.key === key)
      if (idx > -1) {
        localData[t][idx].time = item.time
      } else {
        localData[t].push({
          key: key,
          time: item.time
        })
      }
      localStorage.setItem('askingMenuRefreshTime', JSON.stringify(localData))
    }

    // 如果已经有未读消息，且未超过24小时，则无需再次请求
    function notMoreThan24H(item: any) {
      const moreThan24H = Math.round(Date.now() / 1000) - item.time > 24 * 60 * 60
      if (item.isNew && !moreThan24H) {
        return true
      } else {
        return false
      }
    }
    function checkNews(item: any) {
      const notCheck = notMoreThan24H(item)
      if (notCheck) return true
      const data: any = {}
      data.data = {
        PageID: 1,
        PageSize: 1,
        TimeValue: item.time
      }
      if (item.Exch) {
        data.data.SectorExt = [{ Exch: item.Exch, Inst: item.Inst }]
      } else {
        data.data.InstExt = [{ Exch: item.Market, Inst: item.Inst }]
        // data.data.KeyWords = [item.Name]
      }
      data.headers = {
        token: props.token
      }
      return askApi.getInfoSecretarySearch(data).then((res: any) => {
        return (res.Data || []).length ? true : false
      })
    }
    onUnmounted(() => {
      timer && clearTimeout(timer)
    })
    return {
      ...toRefs(pageData),
      handlerMouseEnter,
      handlerClick
    }
  }
})
